var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, makeObservable } from 'mobx';
import { runtime } from '../../Runtime';
export class BrowserPreload {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    loadedAudioFiles = [];
    loadedVideoFiles = [];
    loadedImageFiles = [];
    preloadAudio(url) {
        if (this.loadedAudioFiles.includes(url)) {
            return;
        }
        const audio = new Audio();
        // once this file loads, it will call loadedAudio()
        // the file will be kept by the browser as cache
        audio.addEventListener('canplaythrough', this.onLoadedAudio, false);
        audio.src = url;
    }
    onLoadedAudio(l) {
        this.loadedAudioFiles.push(l.currentTarget.currentSrc);
    }
    async fetchAndCacheVideo(url) {
        if (runtime.isBot)
            return;
        if (url.startsWith('data:'))
            return;
        if (!url.includes('schlaukopf.de') && !url.startsWith('/'))
            return;
        if (runtime.solidBrowserRuntime.browserBandwidth.isSlowConnection)
            return;
        if (this.loadedVideoFiles.includes(url))
            return;
        const req = new XMLHttpRequest();
        req.open('GET', url, true);
        req.setRequestHeader('Cache-Control', 'max-age=86400'); // 24 hours
        req.responseType = 'blob';
        const browserPreload = this;
        req.onload = function () {
            // Onload is triggered even on 404
            // so we need to check the status code
            if (this.status === 200) {
                const videoBlob = this.response;
                const vidSrc = URL.createObjectURL(videoBlob); // IE10+
                browserPreload.preloadedVideoSources.set(url, vidSrc);
                console.log('video preload completed', url);
            }
        };
        req.onerror = function () {
            console.log('video preload errored', url);
        };
        req.send();
        this.loadedVideoFiles.push(url);
        /*
    
        if (!('caches' in window)) return;
    
        // https://developers.google.com/web/fundamentals/media/fast-playback-with-video-preload
        const cache = await window.caches.open('video-preload-cache');
    
        // Check first if video is in the cache.
        const cacheResponse = await cache.match(url);
        // Let's return cached response if video is already in the cache.
        if (cacheResponse) {
          console.log('video already in cache', url);
          return cacheResponse;
        }
        console.log('video preload', url);
        // Otherwise, fetch the video from the network.
        const networkResponse = await fetch(url, { mode: 'cors' });
        const data = await networkResponse.arrayBuffer();
        // cache.put(url, networkResponse.clone());
        const response = new Response(data);
        cache.put(url, response.clone());
        this.loadedVideoFiles.push(url);
        return networkResponse; */
    }
    preloadImage(url) {
        if (this.loadedImageFiles.includes(url))
            return;
        new Image().src = url;
        console.log('preload image ', url);
        this.loadedImageFiles.push(url);
    }
    preloadImages(urls) {
        for (const url of urls) {
            this.preloadImage(url);
        }
    }
    preloadedVideoSources = new Map();
    getPreloadedVideoBlobSrc(src) {
        if (this.preloadedVideoSources.has(src)) {
            return this.preloadedVideoSources.get(src);
        }
        return '';
    }
}
__decorate([
    action.bound
], BrowserPreload.prototype, "onLoadedAudio", null);
